import './dashboard-not-found-page.scss';

export const DashboardNotFoundPage = () => {
  return (
    <div className="glu-not-found-page">
      <h1 className="glu-not-found-page-error-code">404</h1>
      <p className="glu-not-found-page-error-status">Page Not Found</p>
      <p className="glu-not-found-page-secondary-text">The page doesn&apos;t exist</p>
    </div>
  );
};
